@use '../../scss/utility/functions' as utility;

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: utility.wb-pixel-to-rem(20px);
  min-width: utility.wb-pixel-to-rem(20px);
  border-radius: utility.wb-pixel-to-rem(10px);
  margin: auto;
  white-space: nowrap;
  background: var(--bg-color);
  color: var(--text-color);
}

.has-padding {
  padding: 0 utility.wb-pixel-to-rem(7px);
}

:host([variant='primary']) {
  --bg-color: var(--wb-blue-45);
  --text-color: var(--wb-white);
}

:host([variant='secondary'][theme='light']) {
  --bg-color: var(--wb-black);
  --text-color: var(--wb-white);
}

:host([variant='secondary'][theme='dark']) {
  --bg-color: var(--wb-white);
  --text-color: var(--wb-black);
}

:host([variant='tertiary'][theme='light']) {
  --bg-color: var(--wb-grey-85);
  --text-color: var(--wb-grey-35);
}

:host([variant='tertiary'][theme='dark']) {
  --bg-color: var(--wb-grey-35);
  --text-color: var(--wb-white);
}

:host([variant='success']) {
  --bg-color: var(--wb-green-35);
  --text-color: var(--wb-white);
}

:host([variant='warning']) {
  --bg-color: var(--wb-yellow-50);
  --text-color: var(--wb-black);
}

:host([variant='error']) {
  --bg-color: var(--wb-red-35);
  --text-color: var(--wb-white);
}
